// 第1张
const imgAllA = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724816138174/AC%20charging.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724816136641/AC%20charging%20(1).jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001485961/euPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725002404705/euH1.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001640021/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725006097080/ukH1.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736749684240/5_1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736749683105/5_1_M.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090747676/M1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090747494/M1-m.jpg',
    },
};
export const imgLocaleA: any = {
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    au: imgAllA.AU,
    kr: imgAllA.EU,
    ph: imgAllA.PH,
};

// 第2张
const imgAllB = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724816137372/Solar%20charging.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724816137105/Solar%20charging%20(1).jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001476051/euPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725002404871/euH2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001640121/ukPC3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725006097202/ukH2.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1737525481594/5_2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1737525511050/5_2_M.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090841273/M3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090841104/M2-m.jpg',
    },
};
export const imgLocaleB: any = {
    us: imgAllB.NA,
    ca: imgAllB.NA,
    br: imgAllB.NA,
    mx: imgAllB.NA,
    uk: imgAllB.UK,
    eu: imgAllB.EU,
    de: imgAllB.EU,
    fr: imgAllB.EU,
    it: imgAllB.EU,
    es: imgAllB.EU,
    au: imgAllB.AU,
    kr: imgAllB.EU,
    ph: imgAllB.PH,
};

// 第3张
const imgAllC = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724816137648/Car%20charging.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724816137838/Car%20charging%20(1).jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001475755/euPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725002404503/euH3.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001640378/ukPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725006097404/ukH3.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736749684453/5_3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736749683420/5_3_M.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090879353/M2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090879481/M3-m.jpg',
    },
};
export const imgLocaleC: any = {
    us: imgAllC.NA,
    ca: imgAllC.NA,
    br: imgAllC.NA,
    mx: imgAllC.NA,
    uk: imgAllC.UK,
    eu: imgAllC.EU,
    de: imgAllC.EU,
    fr: imgAllC.EU,
    it: imgAllC.EU,
    es: imgAllC.EU,
    au: imgAllC.AU,
    kr: imgAllC.EU,
    ph: imgAllC.PH,
};

// 第4张
const imgAllD = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724816137161/Generator%20charging.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724816136808/Generator%20charging%20(1).jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001475534/euPC4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725002404306/euH4.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725001640583/ukPC4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725006097571/ukH4.jpg',
    },
    AU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736749683628/5_4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736749684019/5_4_M.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090955446/M4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090955594/M4-m.jpg',
    },
};
export const imgLocaleD: any = {
    us: imgAllD.NA,
    ca: imgAllD.NA,
    br: imgAllD.NA,
    mx: imgAllD.NA,
    uk: imgAllD.UK,
    eu: imgAllD.EU,
    de: imgAllD.EU,
    fr: imgAllD.EU,
    it: imgAllD.EU,
    es: imgAllD.EU,
    au: imgAllD.AU,
    kr: imgAllD.EU,
    ph: imgAllD.PH,
};
